export default __webpack_public_path__ + "static/media/woopra.66c1da27.svg";